import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {AssistanceTicket} from '../../../../models/assistanceticket';
import {AssistanceService} from '../../../../models/assistanceservice';
import {AssistanceCategory} from '../../../../models/assistance-category';
import {AssistanceProvider} from '../../../../models/assistance-provider';
import { AssistanceTicketsTypesService } from '../assistance-tickets-types.service';
import { IamService } from '../../../../services/iam.service';
import * as _ from 'lodash';
import { AssistanceTicketSvc } from '../../services/assistance-ticket.service';
import { ApiService } from '../../../../api/api.service';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { LoaderService } from '../../../../api/loader.service';
@Component({
    selector: 'app-cancel-tickets-form',
    templateUrl: './cancel-tickets-form.component.html',
    styleUrls: ['./cancel-tickets-form.component.css'],
    providers: [
        AssistanceTicketSvc
    ],
    standalone: false
})
export class CancelTicketsFormComponent implements OnInit {

  @Input() Ticket: EventEmitter<any>;
  @Input() disabled: EventEmitter<boolean>;
  @Input() sds_provider: boolean = false;
  @Input() buca_plan_service: boolean = false;
  @Input() sinister_plan_service: boolean = false;
  @Input() assistance_plan_service: any;
  @Input() totalCount: number = 0;
  editticket: AssistanceTicket;
  cancellation_reason_typology: any;
  cancellation_reason_subtypology: any;
  editcategory: AssistanceCategory;
  editservice: AssistanceService;
  editprovider: AssistanceProvider;
  ticket_types: any[] = [];
  types: any[] = [];
  iAm = null;
  subtypes:any
  catalog_cancellation_reasons = [];
  catalog_subtypologies = [];
  SubCategory =""
  @Output() create = new EventEmitter<any>();
  @Output() cancelEvent = new EventEmitter();
  isDisabled = false;

  isDeadService: boolean = null;
  ticket_provider_arrived: boolean = false;

  constructor(
    private typesService: AssistanceTicketsTypesService,
    private iam: IamService,
    private translate: TranslateService,
    private messageService: MessageService,
    private ticketSvc: AssistanceTicketSvc,
    private loaderService: LoaderService,
    private api: ApiService) {
    this.iAm = this.iam.isRole;
  }

  ngOnInit() {
    // this.api.assistancesales.get_subtype().promise()
    // .then((resp) => {
    //   this.subtypes = resp
     
    // });
    
    
    this.api.typologies.get().params({ "catalog": "cancellation_reason" }).promise()
      .then((resp) => {
        
        this.catalog_cancellation_reasons = resp.data[0].typologies;
        this.catalog_subtypologies = [];

      })
      .catch((e) => {
        
      })

    this.reset();
    this.types = this.typesService.getTypes();
    if (this.disabled) {
      this.disabled.subscribe(disabled => {
        this.isDisabled = disabled;
      });
    }

    this.Ticket.subscribe((data: any) => {
      this.editticket = Object.assign({}, data.Ticket);
      this.ticket_provider_arrived = data.ticket_provider_arrived;

      let allowed_types = [];
      if (this.iAm(['supervisor'])) {
        // this.ticket_types = [this.types[5], this.types[6]];
        allowed_types = [
          this.ticketSvc.CANCELED_BY_SUPERVISOR,
          this.ticketSvc.CANCELED_BY_CLIENT,
          this.ticketSvc.CANCELED_BY_CLIENT_WITHOUT_COST,
          // this.ticketSvc.CANCELED_SERVICE_BY_REIMBURSEMENT
        ];
      }
      else if (this.iAm(['assistance_dispatcher'])) {
        
      }
      else {
        allowed_types = [
          this.ticketSvc.CANCELED_BY_CLIENT,
          this.ticketSvc.CANCELED_BY_CLIENT_WITHOUT_COST,
          // this.ticketSvc.CANCELED_SERVICE_BY_REIMBURSEMENT
        ];
      }

      this.editticket.comment = '';
      

      if (this.editticket.service_id) {
        this.editservice = this.editticket.service;
        this.editcategory = this.editticket.service.category;
      }
      if (this.editticket.provider_id && this.editticket.provider_status === 1) {
        this.editprovider = this.editticket.provider;
        // allowed_types.push(
        //   this.ticketSvc.CANCELED_BY_PROVIDER
        // );
      }

      this.editticket.ticket_type = allowed_types[0];

      // Tranform allowed types
      this.ticket_types = [];
      for (let i = 0; i < allowed_types.length; i++) {
        const type = allowed_types[i];
        const ticket_type = _.find(this.typesService.types, a => {
          return a.value === type;
        });

        if (ticket_type) {
          this.ticket_types.push(ticket_type);
        }
      }
    });

    
  }

  reset() {
    this.editticket = new AssistanceTicket();
    this.editcategory = new AssistanceCategory();
    this.editservice = new AssistanceService();
    this.editprovider = new AssistanceProvider();
  }

  onCancel() {
    this.reset();
    this.cancelEvent.emit();
  }

  onSetType(value) {
    this.editticket.ticket_type = parseInt(value);
  }

  async onSubmit() {
    // Dead service, show message if ticket 4 not exists
    if (this.isDeadService == true) {
      if (!this.ticket_provider_arrived) {
        this.translate
          .get('To mark as dead service, you must mark Provider Arrived ticket (Step 4)')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `${res}`,
            });
          });
        return;
      }
    }
    
    if(this.assistance_plan_service.buca_apply == 1 && this.totalCount >= 3){
      this.loaderService.display(true);
      const response = await this.verifyBucaCase();
      this.loaderService.display(false);
      
      if(response == 2) return;

      if(response == -1) {
        this.messageService.add({
          severity: 'error',
          summary: 'Resultado',
          detail: 'Error en la validación del caso con BUCA.',
          life: 4000
        });
      }
    }
    
    if(this.assistance_plan_service.sinister_apply == 1 && this.totalCount >= 3){
      this.loaderService.display(true);
      const response = await this.verifySinisterCase();
      this.loaderService.display(false);
      
      if(response == 2) return;

      if(response == -1) {
        this.messageService.add({
          severity: 'error',
          summary: 'Resultado',
          detail: 'Error en la validación del caso con Modulo de Siniestros.',
          life: 4000
        });
      }
    }
    

    this.isDisabled = true;
    this.create.emit({ ticket: this.editticket, is_dead_service: this.isDeadService });
    this.reset();

  }

  verifyBucaCase():Promise<number> {
    return new Promise((resolve, reject) => {
      this.api.buca.verifyBucaCase(this.editticket.case_id).promise()
        .then(response => {
          if(response['status'] == 2){
            this.messageService.add({
              severity: 'error',
              summary: 'Resultado',
              detail: 'Ya se inició la atención en el portal Buca por lo que el caso no se puede cancelar.',
              life: 4000
            });

          } else if(response['status'] == 1){
            this.editticket.buca_action = 2; // Accion relacionada a Buca: 2 - Cancelar caso

          }

          resolve(response['status'])
        })
        .catch((error) => {
          reject(-1);
        });
    })
  }
  verifySinisterCase():Promise<number> {
    return new Promise((resolve, reject) => {
      this.api.sds.verifySinisterCase(this.editticket.case_id).promise()
        .then(response => {
          
          if(response['status'] == 2){
            this.messageService.add({
              severity: 'error',
              summary: 'Resultado',
              detail: 'Ya se inició la atención en el portal de Siniestros por lo que el caso no se puede cancelar.',
              life: 4000
            });

          } else if(response['status'] == 1){
            this.editticket.sinister_action = 2; // Accion relacionada a Siniestros: 2 - Cancelar caso

          } else if(response['status'] == 3){
            this.messageService.add({
              severity: 'error',
              summary: 'Resultado',
              detail: 'No se encuentran avances en el siniestro.',
              life: 4000
            });

          }

          resolve(response['status'])
        })
        .catch((error) => {
          reject(-1);
        });
    })
  }

  onChangeTypology(event) {
    this.catalog_subtypologies = [];
    if (event.target.value) {
      let typology = _.find(this.catalog_cancellation_reasons, { "id": +event.target.value });
      if (typology) {
        this.catalog_subtypologies = typology.subtypologies;
        this.editticket.cancellation_reason_typology = typology.description;
      }
    }
  }

  onChangeSubtypology(event) {
    if (event.target.value) {
      let subtypology = _.find(this.catalog_subtypologies, { "id": +event.target.value });
      if (subtypology) {
        this.editticket.cancellation_reason_subtypology = subtypology.description;
      }
    }
  }

}
